export default {
    ARTICLE_SECTION: "ARTICLE_SECTION",
    PRESENTATION_BOX: "PRESENTATION_BOX",
    CARD_LABEL: "CARD_LABEL",
    BLOCK_TITLE: "BLOCK_TITLE",
    CONTACT_FORM: "CONTACT_FORM",
    COLOR_IMAGE_BLOCK: "COLOR_IMAGE_BLOCK",
    BLOCK_WITH_TITLE: "BLOCK_WITH_TITLE",
    TEXT_BLOCK_WITH_TITLE: "TEXT_BLOCK_WITH_TITLE",
    DESCRIPTION_CARD_WITH_LOGO: "DESCRIPTION_CARD_WITH_LOGO",
    DESCRIPTION_SERVICE_CARD: "DESCRIPTION_SERVICE_CARD",
    DESCRIPTION_SERVICES_ITEM: "DESCRIPTION_SERVICES_ITEM",
    TABS_COMPONENT: "TABS_COMPONENT",
    DESCRIPTION_TABS: "DESCRIPTION_TABS",
    DESCRIPTION_TABS_ITEM: "DESCRIPTION_TABS_ITEM",
    ILLUSTRATION_TABS: "ILLUSTRATION_TABS",
    ILLUSTRATION_TAB_ITEM: "ILLUSTRATION_TAB_ITEM",
    SUB_PAGE_REDIRECT: "SUB_PAGE_REDIRECT",
    GEOGRAPHIC_MAP: "GEOGRAPHIC_MAP",
    SUBPAGE_SEARCH: "SUBPAGE_SEARCH",
    MAILTO: "MAILTO",
    STEPS: "STEPS",
    STEP: "STEP",
    GRADIENT_BUTTON: "GRADIENT_BUTTON",
    WITNESS_CARD: "WITNESS_CARD",
    IFRAME: "IFRAME",
    PRODUCT_BLOCK: "PRODUCT_BLOCK",
    CONTACT_BLOCK: "CONTACT_BLOCK",
    DESCRIPTION_SECTION: "DESCRIPTION_SECTION",
    DESCRIPTION_SECTION_ITEM: "DESCRIPTION_SECTION_ITEM",
    SOLUTION_TYPE_ORGANISATION: "SOLUTION_TYPE_ORGANISATION",
    OFFERING_CARD: "OFFERING_CARD",
    OFFER_PRESENTATION_CARD: "OFFER_PRESENTATION_CARD",
    CARD_PRICE_ROW_ITEM: "CARD_PRICE_ROW_ITEM",
    CARD_PRICE: "CARD_PRICE",
    INFOS_BLOCK: "INFOS_BLOCK",
    LIST_WRAP: "LIST_WRAP",
    LIST_WRAP_ITEM: "LIST_WRAP_ITEM",
    LIST_INFOS: "LIST_INFOS",
    LIST_INFOS_ITEM: "LIST_INFOS_ITEM",
    COLUMNS_WITH_ICON: "COLUMNS_WITH_ICON",
    COLUMN_WITH_ICON_ITEM: "COLUMN_WITH_ICON_ITEM",
    STAT_CARD: "STAT_CARD",
};
